import React from 'react';

const ApplicationLoaderComponent = (props) => {
  return <div className="screen authentication"><div className="cover authentication loader"><div className="container login loading animated flash infinite slower"></div></div></div>;
};
export default ApplicationLoaderComponent;
